export default "__VITE_ASSET__DCu1bTKT__"